import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';

export const kymw54Handlers = [
  
  // 商品検索カテゴリ関連マスタ情報取得 /kymw54/getCategoryCandidacyGoodsInfo
  http.post(PlessService.SERVICE.getCategoryCandidacyGoodsInfo.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getCategoryCandidacyGoodsInfo.url, req);
    return HttpResponse.json(getCategoryCandidacyGoodsInfoResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // カテゴリ情報取得 /kymw54/get54CategoryInfo
  http.post(PlessService.SERVICE.get54CategoryInfo.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.get54CategoryInfo.url, req);
    return HttpResponse.json(get54CategoryInfoResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // カテゴリ関連情報取得 /kymw54/getGoodsCategoryInfo
  http.post(PlessService.SERVICE.getGoodsCategoryInfo.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getGoodsCategoryInfo.url, req);
    return HttpResponse.json(getGoodsCategoryInfoResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // カテゴリ関連情報更新 /kymw54/updateGoodsCategoryInfo
  http.post(PlessService.SERVICE.updateGoodsCategoryInfo.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.updateGoodsCategoryInfo.url, req);
    return HttpResponse.json(updateGoodsCategoryInfoResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

];

const getCategoryCandidacyGoodsInfoResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      TotalNum: 4,
      StartDispNum: 1,
      EndDispNum: 4,
      GoodsList: [
        {
          MediumType: '001',
          MediumName: 'ハピデリ',
          MediumTypeName: '001：ハピデリ',
          ClassCode: '01',
          ClassName: '農業',
          ClassCodeName: '01：農業',
          SmallClassCode: '010003',
          SmallClassName: 'いよかん',
          SmallClassCodeName: '010003：いよかん',
          Pcode: 'P0003417',
          GoodsName: 'いよかん',
          GoodsStandardName: '600g（M4個）',
          CoopFlgI: '1',
          CoopFlgTo: '1',
          CoopFlgGu: '1',
          CoopFlgChi: '1',
          CoopFlgSa: '1',
          CoopFlgTou: '1',
          CoopFlgNa: '1',
          CoopFlgNi: '1',
        },
        {
          MediumType: '001',
          MediumName: 'ハピデリ',
          MediumTypeName: '001：ハピデリ',
          ClassCode: '01',
          ClassName: '農業',
          ClassCodeName: '01：農業',
          SmallClassCode: '010003',
          SmallClassName: 'いよかん',
          SmallClassCodeName: '010003：いよかん',
          Pcode: 'P1202308',
          GoodsName: 'いよかん',
          GoodsStandardName: '600g（M又はL）',
          CoopFlgI: '0',
          CoopFlgTo: '0',
          CoopFlgGu: '0',
          CoopFlgChi: '0',
          CoopFlgSa: '0',
          CoopFlgTou: '0',
          CoopFlgNa: '0',
          CoopFlgNi: '0',
        },
        {
          MediumType: '001',
          MediumName: 'ハピデリ',
          MediumTypeName: '001：ハピデリ',
          ClassCode: '01',
          ClassName: '農業',
          ClassCodeName: '01：農業',
          SmallClassCode: '010004',
          SmallClassName: '甘夏',
          SmallClassCodeName: '010004：甘夏',
          Pcode: 'P1196588',
          GoodsName: 'あまなつ（有機栽培）',
          GoodsStandardName: '800g（S～L）',
          CoopFlgI: '1',
          CoopFlgTo: '1',
          CoopFlgGu: '1',
          CoopFlgChi: '1',
          CoopFlgSa: '0',
          CoopFlgTou: '0',
          CoopFlgNa: '0',
          CoopFlgNi: '0',
        },
        {
          MediumType: '001',
          MediumName: 'ハピデリ',
          MediumTypeName: '001：ハピデリ',
          ClassCode: '01',
          ClassName: '農業',
          ClassCodeName: '01：農業',
          SmallClassCode: '010004',
          SmallClassName: '甘夏',
          SmallClassCodeName: '010004：甘夏',
          Pcode: 'P2338610',
          GoodsName: 'あまなつ（特別栽培）',
          GoodsStandardName: '800g（L3個）',
          CoopFlgI: '0',
          CoopFlgTo: '0',
          CoopFlgGu: '0',
          CoopFlgChi: '0',
          CoopFlgSa: '1',
          CoopFlgTou: '1',
          CoopFlgNa: '1',
          CoopFlgNi: '1',
        },
      ]
    }
  }
}

const get54CategoryInfoResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      CategoryDiv: '1',
      OrderCode: '2023220',
      Category: [
        {
          OrderCode: '2023220',
          CategoryCode: '002000000',
          CategoryName: 'やさい・くだもの',
          ParentCategoryCode: '',
          CategoryLevel: 1,
          ShowSeq: 1,
          BorderLineDiv: '',
          ShowDiv: '',
          SellAreaDivB: '',
          SellAreaDivN: '',
          SellAreaDivM: '',
          SellAreaDivW: '',
          UpdateDate: '2012/07/10 22:28:38',
          StockLimitFlg: '',
          TimeSaleFlg: '',
          Category: [
            {
              OrderCode: '2023220',
              CategoryCode: '002000000',
              CategoryName: 'きゅうり・トマトなど',
              ParentCategoryCode: '002000000',
              CategoryLevel: 2,
              ShowSeq: 1,
              BorderLineDiv: '',
              ShowDiv: '',
              SellAreaDivB: '',
              SellAreaDivN: '',
              SellAreaDivM: '',
              SellAreaDivW: '',
              UpdateDate: '2012/07/10 22:28:38',
              StockLimitFlg: '',
              TimeSaleFlg: '0',
              Category: [
                {
                  OrderCode: '2023220',
                  CategoryCode: '002000000',
                  CategoryName: 'きゅうり',
                  ParentCategoryCode: '002000000',
                  CategoryLevel: 2,
                  ShowSeq: 1,
                  BorderLineDiv: '',
                  ShowDiv: '',
                  SellAreaDivB: '',
                  SellAreaDivN: '',
                  SellAreaDivM: '',
                  SellAreaDivW: '',
                  UpdateDate: '2012/07/10 22:28:38',
                  StockLimitFlg: '',
                  TimeSaleFlg: '0',
                }
              ]
            },
            {
              OrderCode: '2023220',
              CategoryCode: '002000000',
              CategoryName: '葉もの・ねぎ類など',
              ParentCategoryCode: '002000000',
              CategoryLevel: 2,
              ShowSeq: 2,
              BorderLineDiv: '',
              ShowDiv: '',
              SellAreaDivB: '',
              SellAreaDivN: '',
              SellAreaDivM: '',
              SellAreaDivW: '',
              UpdateDate: '2012/07/10 22:28:38',
              StockLimitFlg: '',
              TimeSaleFlg: '1',
              Category: [
              ]
            },
          ]
        },
        {
          OrderCode: '2023220',
          CategoryCode: '003000000',
          CategoryName: 'お魚',
          ParentCategoryCode: '',
          CategoryLevel: 1,
          ShowSeq: 2,
          BorderLineDiv: '',
          ShowDiv: '',
          SellAreaDivB: '',
          SellAreaDivN: '',
          SellAreaDivM: '',
          SellAreaDivW: '',
          UpdateDate: '2014/11/19 10:06:51',
          StockLimitFlg: '',
          TimeSaleFlg: '',
          Category: [
            {
              OrderCode: '2023220',
              CategoryCode: '003001000',
              CategoryName: 'お刺身・鮮魚',
              ParentCategoryCode: '003000000',
              CategoryLevel: 2,
              ShowSeq: 1,
              BorderLineDiv: '',
              ShowDiv: '',
              SellAreaDivB: '',
              SellAreaDivN: '',
              SellAreaDivM: '',
              SellAreaDivW: '',
              UpdateDate: '2014/11/19 10:06:51',
              StockLimitFlg: '',
              TimeSaleFlg: '',
              Category: [
              ]
            },
            {
              OrderCode: '2023220',
              CategoryCode: '003002000',
              CategoryName: '切り身・下処理済魚',
              ParentCategoryCode: '003000000',
              CategoryLevel: 2,
              ShowSeq: 2,
              BorderLineDiv: '',
              ShowDiv: '',
              SellAreaDivB: '',
              SellAreaDivN: '',
              SellAreaDivM: '',
              SellAreaDivW: '',
              UpdateDate: '2014/11/19 10:06:51',
              StockLimitFlg: '',
              TimeSaleFlg: '',
              Category: [
              ]
            },
          ]
        }
      ]
    }
  }
}

const getGoodsCategoryInfoResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      Category: {
        List: [
          {
            ClassCode: '01',
            ClassName: '農産',
            ClassCodeName: '01：農産',
            SmallClassCode: '010007',
            SmallClassName: 'デコポン',
            SmallClassCodeName: '010007：デコポン',
            PCode: 'P2537658',
            GuideGoodsName: '不知火（天候被害果・サイズ込）',
            GuideStandardName: '1.8kg（M～3L）',
            CoopFlgI: '0',
            CoopFlgTo: '0',
            CoopFlgGu: '0',
            CoopFlgChi: '0',
            CoopFlgSa: '1',
            CoopFlgTou: '1',
            CoopFlgNa: '1',
            CoopFlgNi: '1',
            ECShowSeq: 1,
          },
          {
            ClassCode: '01',
            ClassName: '農産',
            ClassCodeName: '01：農産',
            SmallClassCode: '010015',
            SmallClassName: '他柑橘',
            SmallClassCodeName: '010015：他柑橘',
            PCode: 'P2551520',
            GuideGoodsName: 'ぶんたん（サイズ込）',
            GuideStandardName: '4kg箱（M～4L）',
            CoopFlgI: '1',
            CoopFlgTo: '1',
            CoopFlgGu: '1',
            CoopFlgChi: '1',
            CoopFlgSa: '2',
            CoopFlgTou: '2',
            CoopFlgNa: '2',
            CoopFlgNi: '2',
            ECShowSeq: 2,
          },
          {
            ClassCode: '01',
            ClassName: '農産',
            ClassCodeName: '01：農産',
            SmallClassCode: '010101',
            SmallClassName: 'グレープフルーツR',
            SmallClassCodeName: '010101：グレープフルーツR',
            PCode: 'P0138339',
            GuideGoodsName: 'グレープフルーツ（ルビー種）',
            GuideStandardName: '850g（3～4個）',
            CoopFlgI: '2',
            CoopFlgTo: '2',
            CoopFlgGu: '2',
            CoopFlgChi: '2',
            CoopFlgSa: '3',
            CoopFlgTou: '3',
            CoopFlgNa: '3',
            CoopFlgNi: '3',
            ECShowSeq: 3,
          },
          {
            ClassCode: '01',
            ClassName: '農産',
            ClassCodeName: '01：農産',
            SmallClassCode: '010104',
            SmallClassName: 'バレンシアオレンジ',
            SmallClassCodeName: '010104：バレンシアオレンジ',
            PCode: 'P0004588',
            GuideGoodsName: 'オレンジ（バレンシア種）（増量）',
            GuideStandardName: '600g（4個＋1個）',
            CoopFlgI: '3',
            CoopFlgTo: '3',
            CoopFlgGu: '3',
            CoopFlgChi: '3',
            CoopFlgSa: '4',
            CoopFlgTou: '4',
            CoopFlgNa: '4',
            CoopFlgNi: '4',
            ECShowSeq: 4,
          },
        ]
      }
    }
  }
}

const updateGoodsCategoryInfoResponse = {
  "status": "ok",
  "message": "処理終了",
}